<template>
	<div
		class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto my-auto bg-color--light--2"
	>
		<div>
			<h4 class="text-center pt-3 pb-3">ایجاد قرارداد جدید</h4>
			<form class="form">
				<div
					class="alert alert-danger"
					role="alert"
					id="alert"
					v-show="alert"
				></div>
				<div class="container">
					<!----------------- net_amount & downpayment ----------------->
					<div class="row justify-content-around">
						<!-- net_amount -->
						<div class="col-md-3">
							<div class="form-group">
								<label
									class="form__label text-uppercase font-size--15 font-w--500"
									>{{ $t("contract.net_amount") }}</label
								>
								<vue-numeric
									id="net_amount"
									separator=","
									v-model.trim="$v.net_amount.$model"
									class="form-control"
									:class="{ 'is-invalid': $v.net_amount.$error }"
									@blur="$v.net_amount.$touch()"
								></vue-numeric>

								<div class="invalid-feedback" v-if="!$v.net_amount.required">
									مبلغ فاکتور را وارد کنید
								</div>
								<div class="invalid-feedback" v-if="!$v.net_amount.minValue">
									مبلغ فاکتور را درست وارد کنید
								</div>
							</div>
						</div>

						<!-- downpayment -->
						<div class="col-md-3">
							<div class="form-group">
								<label
									class="form__label text-uppercase font-size--15 font-w--500"
									>{{ $t("contract.downpayment") }}</label
								>
								<vue-numeric
									id="downpayment"
									separator=","
									v-model.trim="$v.downpayment.$model"
									class="form-control"
									:class="{ 'is-invalid': $v.downpayment.$error }"
									@blur="$v.downpayment.$touch()"
								></vue-numeric>
								<div class="invalid-feedback" v-if="!$v.downpayment.required">
									مقدار پیش پرداخت را وارد کنید
								</div>
								<div class="invalid-feedback" v-if="!$v.downpayment.min">
									مقدار پیش پرداخت باید حداقل
									<span>
										<vue-numeric
											separator=","
											v-model="downpaymentMin"
											read-only
										>
										</vue-numeric> </span
									>ریال باشد
								</div>
							</div>
						</div>
					</div>

					<!----------------- number_of_instalment & invoice_number ----------------->
					<div class="row justify-content-around">
						<!-- number_of_instalment -->
						<div class="col-md-3">
							<div class="form-group">
								<label
									class="form__label text-uppercase font-size--15 font-w--500"
									>{{ $t("contract.number_of_instalment") }}</label
								>
								<div class="input-group mb-3">
									<select
										class="custom-select rounded-left"
										id="number_of_instalment"
										v-model.trim="$v.number_of_instalment.$model"
										:class="{ 'is-invalid': $v.number_of_instalment.$error }"
										@blur="$v.number_of_instalment.$touch()"
									>
										<option selected>انتخاب...</option>
										<!-- <option value="6">۶</option> -->
										<option value="12">۱۲</option>
										<option value="24">۲۴</option>
									</select>
									<div class="input-group-prepend rounded-left">
										<label
											class="input-group-text rounded-right"
											for="number_of_instalment"
											>ماه</label
										>
									</div>
								</div>

								<div
									class="invalid-feedback"
									v-if="!$v.number_of_instalment.required"
								>
									تعداد اقساط را وارد کنید
								</div>
							</div>
						</div>

						<!-- invoice_number -->
						<div class="col-md-3">
							<div class="form-group">
								<label
									class="form__label text-uppercase font-size--15 font-w--500"
									>{{ $t("contract.invoice_number") }}</label
								>
								<input
									id="invoice_number"
									type="string"
									v-model.trim="$v.invoice_number.$model"
									class="form-control"
									:class="{ 'is-invalid': $v.invoice_number.$error }"
									@blur="$v.invoice_number.$touch()"
								/>
								<div
									class="invalid-feedback"
									v-if="!$v.invoice_number.required"
								>
									شماره فاکتور را وارد کنید
								</div>
							</div>
						</div>
					</div>

					<!----------------- invoice_date & invoice_pic ----------------->
					<div class="row justify-content-around">
						<!-- invoice_date -->
						<div class="col-md-3">
							<div class="form-group">
								<label
									class="form__label text-uppercase font-size--15 font-w--500"
									>{{ $t("contract.invoice_date") }}</label
								>
								<div class="input-group mb-3">
									<date-picker
										id="invoice_date"
										v-model.trim="$v.invoice_date.$model"
										:class="{
											'is-invalid': $v.invoice_date.$error,
										}"
										
										placeholder="1399/8/23"
										format="YYYY-MM-DD"
										display-format="dddd jDD jMMMM jYYYY"
										color="#5c6bc0"
									>
										<div slot="label"></div>
									</date-picker>
								</div>
								<div class="invalid-feedback" :class="{ 'd-block': $v.invoice_date.$error }" v-if="!$v.invoice_date.required">
									تاریخ فاکتور را وارد کنید
								</div>
							</div>
						</div>

						<!-- invoice_pic -->
						<div class="col-md-3">
							<div class="form-group">
								<label
									class="form__label text-uppercase font-size--15 font-w--500"
									>{{ $t("contract.invoice_pic") }}</label
								>
								<div class="input-group mb-3">
									<div class="custom-file" v-show="!invoice_pic">
										<input
											id="invoice_pic"
											type="file"
											ref="file"
											class="custom-file-input"
											@blur="$v.invoice_pic.$touch()"
											:class="{ 'is-invalid': $v.invoice_pic.$error }"
											@change="processInvoice_pic()"
										/>
										<label class="custom-file-label" for="invoice_pic"
											>انتخاب فایل</label
										>
									</div>
								</div>
								<div
									class="invalid-feedback"
									:class="{ 'd-block': $v.invoice_pic.$error }"
									v-if="!$v.invoice_pic.required"
								>
									تصویر فاکتور را وارد کنید
								</div>
								<div class="file-listing">
									{{ invoice_pic.name }}
									<span
										class="remove-file"
										v-show="invoice_pic"
										v-on:click="removeInvoice_pic()"
										>حذف</span
									>
								</div>
							</div>
						</div>
					</div>

					<!----------------- description & sign_date ----------------->
					<div class="row justify-content-around">
						<!-- description -->
						<!-- <div class="col-md-3">
							<div class="form-group">
								<label
									class="form__label text-uppercase font-size--15 font-w--500"
									>{{ $t("contract.description") }}</label
								>
								<div class="input-group mb-3">
									<textarea
										id="description"
										class="form-control"
										rows="3"
										v-model.trim="$v.description.$model"
										:class="{
											'is-invalid': $v.description.$error,
										}"
										@blur="$v.description.$touch()"
									/>
								</div>
								<div class="invalid-feedback" v-if="!$v.description.required">
									تاریخ فاکتور را وارد کنید
								</div>
							</div>
						</div> -->
						<!-- sign_date -->
						<div class="col-md-3">
							<div class="form-group" v-show="in_company">
								<label
									class="form__label text-uppercase font-size--15 font-w--500"
									>{{ $t("contract.appoint_time") }}</label
								>
								<div class="input-group mb-3">
									<date-picker
										id="appoint_time"
										type="datetime"
										:disable="[
											/00:(.*)/,
											/1[2-3]:(.*)/,
											/0[1-9]:(.*)/,
											/1[8-9]:(.*)/,
											/2[0-4]:(.*)/,
											'Friday',
											'Thursday',
											'2020-12-09',
										]"
										:jumpMinute="20"
										:roundMinute="true"
										:timezone="false"
										v-model.trim="$v.appoint_time.$model"
										:class="{
											'is-invalid': $v.appoint_time.$error,
										}"
										
										placeholder="1399/8/23"
										format="YYYY-MM-DDTHH:mm"
										display-format="dddd jDD jMMMM jYYYY HH:mm"
										color="#5c6bc0"
									>
										<div slot="label"></div>
									</date-picker>
								</div>
								<div class="invalid-feedback"
									:class="{ 'd-block': $v.appoint_time.$error }" v-if="!$v.appoint_time.required">
									قرار ملاقات را وارد کنید
								</div>
							</div>
						</div>
					</div>

					<div class="row justify-content-around">
						<!-- acceptdownpayment -->
						<div class="col-md-8">
							<div class="form-check">
								<input
									type="checkbox"
									class="form-check-input"
									id="incompany"
									v-model="in_company"
								/>
								<label class="form-check-label" for="incompany">{{
									$t("contract.inCompany")
								}}</label>
							</div>
						</div>
					</div>
					<!---------------- acceptdownpayment ------------>
					<div class="row justify-content-around">
						<!-- acceptdownpayment -->
						<div class="col-md-8">
							<div class="form-check">
								<input
									type="checkbox"
									class="form-check-input"
									id="acceptdownpayment"
									v-model.trim="$v.acceptdownpayment.$model"
									:class="{
										'is-invalid': $v.acceptdownpayment.$error,
									}"
									@blur="$v.acceptdownpayment.$touch()"
								/>
								<label class="form-check-label" for="exampleCheck1"
									>دریافت مبلغ
									<span>
										<vue-numeric separator="," v-model="downpayment" read-only>
										</vue-numeric>
									</span>
									ریال به عنوان پیش پرداخت، تایید می شود</label
								>
								<div
									class="invalid-feedback"
									v-if="!$v.acceptdownpayment.accept"
								>
									تایید دریافت پیش پرداخت لازم است
								</div>
							</div>
						</div>
					</div>

					<br />
					<br />

					<div
						class="d-flex justify-content-between align-items-center flex-column pb-4"
					>
						<button
							class="btn btn-bg--primary btn-size--md btn-hover--3d"
							@click.prevent="createContract"
						>
							<span class="btn__text">ثبت</span>
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>
<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

import {
	required,
	minValue,
	requiredIf,
	// minLength,
	// maxLength
} from "vuelidate/lib/validators";
import VueNumeric from "vue-numeric";
// var moment = require('moment');
export default {
	props: ["id"],
	data() {
		return {
			has_contract: false,

			net_amount: "",
			downpayment: "",
			description: "",
			number_of_instalment: "",
			appoint_time: "",
			sign_date: "",
			invoice_date: "",
			invoice_number: "",
			acceptdownpayment: "",
			invoice_pic: "",
			in_company: false,
		};
	},
	created() {
		this.downpayment = this.downpaymentMin;
	},
	computed: {
		downpaymentMin() {
			return this.net_amount * 0.25;
		},
		date() {
			return this.appoint_time.split("T")[0];
		},
		inCompany() {
			return this.in_company;
		},
	},
	watch: {},
	methods: {
		processInvoice_pic() {
			this.invoice_pic = this.$refs.file.files[0];
		},
		removeInvoice_pic() {
			this.invoice_pic = "";
		},
		submitPic(id) {
			return new Promise((resolve, reject) => {
				let contract_doc = new FormData();
				if (this.invoice_pic) {
					contract_doc.append("pre_invoice", this.invoice_pic);
				}
				contract_doc.append("contractID", id);
				this.$store
					.dispatch("saveContractDocs", contract_doc)
					.then((resp) => {
						resolve(resp);
					})
					.catch((err) => {
						reject(err);
						this.$noty.error(this.$t("alert.contractPicErr"));
					});
			});
		},
		createContract() {
			let contract_data = {
				customer: this.id,
				net_amount: this.net_amount,
				downpayment: this.downpayment,
				description: this.description,
				number_of_instalment: this.number_of_instalment,
				sign_date: this.appoint_time.split("T")[0],
				appoint_time: this.appoint_time,
				invoice_date: this.invoice_date,
				invoice_number: this.invoice_number,
			};
			console.log("piont_time: " + this.appoint_time);
			console.log("whatcher: " + this.inCompany);
			this.$v.$touch();
			
			if (this.$v.$invalid) {
				// this.submitStatus = "ERROR";
				this.$noty.info(this.$t("alert.alertInvalidField"));
				// errorMsgInvalidField.show();
				console.log(this.$v);
			} else {
				let load = this.$loading.show();
				this.$store
					.dispatch("createSupplierContract", contract_data)
					.then((resp) => {
						console.log(resp);
						this.submitPic(resp.body.id)
							.then((resp) => {
								console.log(resp);
								load.hide()
								this.$noty.success(this.$t("alert.successContractCreated"));
								setTimeout(() => {
									this.$routerTab.close("add-contract");
								}, 300);
							})
							.catch((err) => {
								console.log(err);
								load.hide()
								if (err.body.pre_invoice) {
									const finalInvoiceErr = err.body.pre_invoice[0];
									this.$noty.error(finalInvoiceErr);
								} else {
									const errMsgpic = err.body.Error;
									this.$noty.error(errMsgpic);
								}
							});
					})
					.catch((err) => {
						load.hide()
						console.log(err);
						if (err.body.Error) {
							const errMsg = err.body.Error;
							this.$noty.error(errMsg);
						} else if (err.body.appoint_time) {
							const appointTimeErr = err.body.appoint_time[0];
							this.$noty.error(appointTimeErr);
						}
					});
			}
		},
	},
	validations: {
		net_amount: {
			required,
			minValue: minValue(10000000),
		},
		downpayment: {
			required,
			min(value) {
				if (value < this.downpaymentMin) {
					return false;
				} else {
					return true;
				}
			},
		},
		description: {
			//   required,
		},
		number_of_instalment: {
			required,
		},
		appoint_time: {
			required: requiredIf(function(){
				return this.inCompany
			}),
			// isrequir() {
			// 	if (this.inCompany) {
			// 		console.log("whatch: " + this.inCompany);
			// 		return true;
			// 	} else {
			// 		console.log("rrrrrrrrrrrrrr");
			// 		return false;
			// 	}
			// },
		},
		invoice_date: {
			required,
		},
		invoice_number: {
			//   required,
		},
		acceptdownpayment: {
			required,
			accept(check) {
				return check;
			},
		},

		invoice_pic: {
			required,
		},
	},
	components: {
		VueNumeric,
		datePicker: VuePersianDatetimePicker,
	},
};
</script>

<style scoped>
.custom-select {
	border-radius: 0px;
}
.vpd-icon-btn {
	display: block;
	/* width: 0%; */
	cursor: pointer;
	background-color: rgb(230, 253, 254) !important;
	padding: 0px 0px 0px 0px !important;
	margin: 0px 0px 0px 0px !important;
	/* height: 0px 0px 0px 0px; */
}
element.style {
	background-color: rgb(230, 253, 254);
}

div.file-listing {
	background-color: rgba(216, 216, 216, 0.493) !important;
	border-radius: 3px;
}

span.remove-file {
	color: red;
	cursor: pointer;
	float: left;
}

input[type="file"] {
	opacity: 0;

	top: -1px;

	position: fixed;
	cursor: pointer;
}
</style>
